(ns firebase.functions
  (:require ["firebase/functions" :as functions]
            [firebase.core :as core :refer [ADMIN_SDK]]))

(defn instance
  "Get Firebase Functions instance. Uses `app-instance` or defaults to `@core/app`."
  ([] (instance @core/app))
  ([app-instance]
   (functions/getFunctions app-instance)))

(defn make-callable 
  ([fn-name] (make-callable (instance) fn-name))
  ([instance fn-name]
   (let [fn-ref  
         (functions/httpsCallable instance fn-name)]
     (fn [data]
       (.then 
         (fn-ref (clj->js data))
         (fn [^js response]
           (js->clj (.-data response))))))))

(defn get-https-function-url
  "Returns the url string for a https cloud function,
   depending on emulator setting. Optionally pass 
   `:region \"region-string\"`"
  
  [function-name & {:keys [region]
                    :or {region "us-central1"}}]
  
  (let [{:keys [projectId emulator] :as config}
        (core/configuration ::core/app)
        
        {:keys [host port]
         :or {host "localhost"}} 
        emulator]
    
    (if emulator
      ;; Emulator URL: http://localhost:5001/<project-id>/<region>/<function-name>
      (str "http://" host ":" port "/" projectId "/" region "/" function-name)
      ;; Production URL: https://<region>-<project-id>.cloudfunctions.net/<function-name>
      (str "https://" region "-" projectId ".cloudfunctions.net/" function-name))))



(defn connect-emulator [domain port]
  (functions/connectFunctionsEmulator (instance) domain port))

